import { render, staticRenderFns } from "./qqVideoNew.vue?vue&type=template&id=e720f4a4&scoped=true&"
import script from "./qqVideoNew.vue?vue&type=script&lang=js&"
export * from "./qqVideoNew.vue?vue&type=script&lang=js&"
import style0 from "./qqVideoNew.vue?vue&type=style&index=0&id=e720f4a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e720f4a4",
  null
  
)

export default component.exports